import React from "react";
import "../styles/app.css";
import { FaCalendarAlt } from 'react-icons/fa';

function formatDateIST(isoString) {
  const date = new Date(isoString);
  return date.toLocaleDateString("en-IN", {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "Asia/Kolkata"
  });
}

export default function OfferCard({ offers, onSelect }) {
  return (
    <div className="card-grid">
      {offers.map((offer, idx) => (
        <div key={idx} className="offer-card" onClick={() => onSelect(offer)}>
          <img src={offer.image.url} alt={offer.title} className="offer-img" />
          <div className="offer-content">
            <h3>
              {offer.title.length > 100 ? offer.title.slice(0, 100) + "..." : offer.title}
            </h3>
            <div className="offer-meta">
              <span className="date">End Date : <FaCalendarAlt /> {formatDateIST(offer.end_date)}</span>
            </div>
            <span className={`bubble ${offer.offer_type.toLowerCase()}`}>
                {offer.offer_type}
              </span>
            <p className="desc">
              {offer.description.length > 80 ? offer.description.slice(0, 80) + "..." : offer.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
